"use client";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import GalleryImage from "./GalleryImage";
import type { RoomImage } from "../types/room";

type GalleryProps = {
  images: RoomImage[];
  roomTitle: string;
};

export default function Gallery({ images, roomTitle }: GalleryProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const slides = images.map((img) => ({
    src: img.url,
    alt: img.alt || `${roomTitle} ${t("photo")}`,
  }));

  return (
    <>
      <div className="mt-6 grid gap-5 auto-rows-max overflow-x-hidden gallery-grid">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => {
              setIndex(i);
              setOpen(true);
            }}
            className="cursor-pointer text-left w-full gallery-item"
            type="button"
            style={{
              gridRow: img.isVertical ? "span 2" : "span 1",
            }}
          >
            <GalleryImage
              url={img.url}
              alt={img.alt || `${roomTitle} ${t("photo")} ${i + 1}`}
              isVertical={img.isVertical}
            />
          </button>
        ))}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={slides}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
      />
    </>
  );
}
